import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
})
export class AboutPageComponent {
  @Output() readonly inquiryRequested = new EventEmitter<void>();

  protected readonly teamMembers = [
    {
      department: 'Development',
      name: 'Amina Wanjiru',
      title: 'Development Director',
    },
    {
      department: 'Strategy',
      name: 'Daniel Mwangi',
      title: 'Site Strategy Lead',
    },
    {
      department: 'Advisory',
      name: 'Grace Njeri',
      title: 'Buyer Advisory Lead',
    },
    {
      department: 'Client Care',
      name: 'Brian Otieno',
      title: 'Client Relations Manager',
    },
    {
      department: 'Design',
      name: 'Faith Kiplagat',
      title: 'Design Coordinator',
    },
    {
      department: 'Delivery',
      name: 'Michael Kariuki',
      title: 'Project Delivery Lead',
    },
    {
      department: 'Site Liaison',
      name: 'Ivy Adhiambo',
      title: 'Construction Liaison',
    },
    {
      department: 'Handover',
      name: 'Samuel Kamau',
      title: 'Handover Coordinator',
    },
  ];
}
